import { IonContent, IonPage } from "@ionic/react";

import { Hero } from "../components/Hero";
import { I } from "../components/icons";
import { Ring } from "../components/Ring";
import { NavRow, RowGroup } from "../components/Rows";
import { Screen } from "../components/Shell";
import { TopBar } from "../components/TopBar";
import { DOW_LABELS, dayLabel, parseDay, todayStr } from "../domain/date";
import { mealWalkWords, programmeWeekNo } from "../domain/programme";
import { steadyFigures, steadyWeekRows, steadyWeekTitle, weekSpan } from "../domain/programmeView";
import { useKaya, usePlayerMode } from "../store/kayaStore";
import "./Train.css";

/**
 * The week as the person sees it (board TrainWeek, ADR-052), reached from Train › Your week: seven
 * rows, the template, its minutes and a tick when done; an empty ring for a day not done or still
 * ahead (no red, no streak), a dash for rest. Change opens Plan my exercise.
 */
export default function TrainWeek() {
  const S = useKaya((s) => s.S);
  const pm = usePlayerMode();
  const today = todayStr();
  const rows = steadyWeekRows(S, today, pm.simple);
  const fig = steadyFigures(S, today, pm.simple);
  const at = S.profile.training?.at;
  const walks = mealWalkWords(S);

  return (
    <IonPage>
      <IonContent>
        <Screen>
          <div className="train-page">
            <TopBar title="Your week" back={{ to: "/train", label: "Back to Train" }} />

            <Hero
              label={`Steady${typeof at === "number" ? ` · from ${dayLabel(todayStr(new Date(at)))}` : ""}`}
              title={steadyWeekTitle(S, today)}
              line={`Week ${programmeWeekNo(S, today)} · ${fig.strengthDone} of ${fig.strengthOf} strength days done`}
              sub={`${weekSpan(today)} · ${fig.plannedMin} min planned`}
            />

            <RowGroup>
              {rows.map((r) => (
                <NavRow
                  key={r.ds}
                  kind={r.isToday && !r.rest ? "link" : "value"}
                  title={`${DOW_LABELS[parseDay(r.ds).getDay()]} · ${r.name}`}
                  subtitle={r.sub ?? undefined}
                  icon={
                    r.done ? (
                      I.check
                    ) : r.rest ? (
                      I.minus
                    ) : (
                      <span className="train-ring">
                        <Ring pct={r.pct} size={22} stroke={3} color="var(--brand)" />
                      </span>
                    )
                  }
                  tone={r.done ? "success" : "default"}
                  value={r.minutes !== null ? `${r.minutes} min` : undefined}
                  {...(r.isToday && !r.rest ? { to: "/train/session" } : {})}
                />
              ))}
            </RowGroup>

            <p className="train-fine">
              Strength days never back to back{walks ? ` · walks ${walks}` : ""}.
            </p>

            <RowGroup>
              <NavRow title="Change" subtitle="Days, minutes and when — your answers" icon={I.edit} to="/train/questions" />
            </RowGroup>
          </div>
        </Screen>
      </IonContent>
    </IonPage>
  );
}
